export default {
  "b2b.prilohy.delete-dialog.title": "Odstranit přílohu",
  "b2b.prilohy.delete-dialog.confrimMessage":
    "Skutečně si přejete odstranit přilohu {name}?"
};
